// extracted by mini-css-extract-plugin
module.exports = {"CodeVerificationPage":"CodeVerificationPage_CodeVerificationPage__1Ru5C","main":"CodeVerificationPage_main__3GXlm"};